var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"use-csv"},[_c('section',{staticClass:"btn",on:{"click":_vm.handlerClick}},[_vm._v(_vm._s(_vm.text))]),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"fileInput",attrs:{"type":"file"},on:{"change":_vm.processFiles}})])
}
var staticRenderFns = []

export { render, staticRenderFns }